<template>
  <div class="d-flex home justify-content-center">
    <Crm />
  </div>
</template>

<script>
import Crm from "../../components/Crm/Crm.vue";

export default {
  components: {
    Crm,
  },
};
</script>